export const MAX_BORROWER_UPLOAD_FILE_SIZE = 100 * 1024 * 1024; // 50mb (note: bucketAV has 2gb limit)

export const MAX_ISO_8601_DATE = new Date('12/31/9999');

// Individual Auth0 tenants could have a different password policy, but this is the standard one.
export const WEAK_PASSWORD_ERROR_MESSAGE =
  'Password is too weak. It must be at least 12 characters and include an uppercase letter, a lowercase letter, a number, and a special character.';
